import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import React, { useState } from 'react'

interface DetailProps {
  listEl: any
  listStatus: string
  userList: any
  documentListing?: any
  mode?: string
}

export const InvoiceAmortisationDetailContent = (props: DetailProps) => {
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)
  const { listEl, userList } = props
  const SubmitDetail = !!['SUBMIT'].includes(listEl?.ApprovalStatus)
  const CompletedDetail = !!['COMPLETED'].includes(listEl?.ApprovalStatus)
  const CancelDetail = !!['CANCELLED'].includes(listEl?.ApprovalStatus)
  return (
    <>
      {/* <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Contract Start Date
        </div>
        <div className="mdDesc"> {formatDate(listEl?.ContractStartDate)} </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Contract End Date
        </div>
        <div className="mdDesc"> {formatDate(listEl?.ContractEndDate)} </div>
      </div>

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          First Amort Date
        </div>
        <div className="mdDesc"> {formatDate(listEl?.FirstAmortDate)} </div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          No. of month
        </div>
        <div className="mdDesc"> {listEl?.Month} </div>
      </div> */}

      <div className="content-wrap left">
        <div className="desc" style={{ color: 'grey' }}>
          Created Date
        </div>
        <div className="mdDesc">{formatDate(listEl?.createdTs)}</div>
      </div>

      <div className="content-wrap right">
        <div className="desc" style={{ color: 'grey' }}>
          Created By
        </div>
        <div className="mdDesc">
          {userList?.find(user => user.ID == listEl?.createdBy)?.name}
        </div>
      </div>

      {(SubmitDetail || CompletedDetail || CancelDetail) && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Submitted Date
            </div>
            <div className="mdDesc">{formatDate(listEl?.submittedTs)}</div>
          </div>

          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Submitted By
            </div>
            <div className="mdDesc">
              {userList?.find(user => user.ID == listEl?.submittedBy)?.name}
            </div>
          </div>
        </>
      )}

      {(CompletedDetail || CancelDetail) && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Approved Date
            </div>
            <div className="mdDesc"> {formatDate(listEl?.approvedTs)}</div>
          </div>

          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Approved By
            </div>
            <div className="mdDesc">
              {' '}
              {
                userList?.filter(user => user.ID == listEl?.approvedBy)[0]?.name
              }{' '}
            </div>
          </div>
        </>
      )}

      {CancelDetail && (
        <>
          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Cancelled Date
            </div>
            <div className="mdDesc">{formatDate(listEl?.CancellationTs)}</div>
          </div>

          <div className="content-wrap right">
            <div className="desc" style={{ color: 'grey' }}>
              Cancelled By
            </div>
            <div className="mdDesc">
              {userList?.find(user => user.ID == listEl?.CancellationBy)?.name}
            </div>
          </div>

          <div className="content-wrap left">
            <div className="desc" style={{ color: 'grey' }}>
              Cancellation Reason
            </div>
            <div className="mdDesc"> {listEl?.CancellationRemark} </div>
          </div>
        </>
      )}

      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
